import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-2 editor__container" }
const _hoisted_2 = { class: "d-flex align-stretch" }
const _hoisted_3 = { class: "d-flex flex-column editor__container__options" }
const _hoisted_4 = {
  key: 0,
  class: "py-2 editor__container"
}
const _hoisted_5 = { class: "d-flex align-stretch" }
const _hoisted_6 = { class: "d-flex flex-column editor__container__options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailOptions = _resolveComponent("MailOptions")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_text_field_filled, {
      label: "Objet du mail",
      modelValue: _ctx.mail.header,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mail.header) = $event)),
      class: "pb-4",
      ref: "headerTextarea",
      "data-cy": "SingleLineMailEditor-mailHeader"
    }, {
      "append-inner": _withCtx(() => [
        _createVNode(_component_MailOptions, {
          text: _ctx.mail.header,
          "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mail.header) = $event)),
          reference: "headerTextarea",
          startPos: _ctx.getTextareaCursorSelection(_ctx.headerTextarea!).selectionStart,
          endPos: _ctx.getTextareaCursorSelection(_ctx.headerTextarea!).selectionEnd,
          onOnMailOptionSelected: _ctx.updateHeader
        }, null, 8, ["text", "startPos", "endPos", "onOnMailOptionSelected"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[8] || (_cache[8] = _createElementVNode("label", {
        for: "mailBody",
        class: "editor__container__label"
      }, "Corps du mail", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Editor, {
          modelValue: _ctx.mail.body,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mail.body) = $event)),
          ref: "bodyTextarea",
          id: "mailBody",
          class: "flex-grow-1",
          editorContentDataCy: 'SingleLineMailEditor-mailBody'
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_MailOptions, {
            text: _ctx.mail.body,
            "onUpdate:text": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mail.body) = $event)),
            reference: "bodyTextarea",
            onOnMailOptionSelected: _ctx.updateBody
          }, null, 8, ["text", "onOnMailOptionSelected"]),
          _createElementVNode("div", null, [
            _withDirectives(_createVNode(_component_v_btn_icon, {
              icon: "$fa-redo-alt",
              size: "small",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.mail.body = ''))
            }, null, 512), [
              [_directive_tooltip, 'Remettre les valeurs par défauts', "bottom"]
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isSignature)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            for: "mailSignature",
            class: "editor__container__label"
          }, "Signature du mail", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Editor, {
              modelValue: _ctx.mail.signature,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mail.signature) = $event)),
              ref: "signatureTextarea",
              id: "mailSignature",
              class: "flex-grow-1"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_MailOptions, {
                text: _ctx.mail.signature,
                "onUpdate:text": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.mail.signature) = $event)),
                reference: "signatureTextarea",
                onOnMailOptionSelected: _ctx.updateSignature
              }, null, 8, ["text", "onOnMailOptionSelected"]),
              _createElementVNode("div", null, [
                _withDirectives(_createVNode(_component_v_btn_icon, {
                  icon: "$fa-redo-alt",
                  size: "small",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.mail.signature = ''))
                }, null, 512), [
                  [_directive_tooltip, 'Remettre les valeurs par défauts', "bottom"]
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}